import axios from 'axios';
import { EVENT, DATE_RANGE } from '@/lib/const';
import { getISODate } from '@/lib/utils';
import { DEPARTMENT } from '@/models/departments';

const headers = {
  headers: {
    Authorization: window.localStorage.getItem('token'),
  },
};
const origin = `${process.env.VUE_APP_ORIGIN}`;
const prefix = 'api';
const originPath = `${origin}/${prefix}/admins/events`;
const routes = {
  get: {
    events: originPath,
    chatActionEndEventAggregates: `${originPath}/chat-action-end`,
    download: `${originPath}/download`,
  },
};

export const getEvents = ({
  type = EVENT.HOURLY_CHAT_STATISTICS,
  date = getISODate(new Date()),
  dateRange = DATE_RANGE.DAY,
  supportId,
}) => {
  const params = `?${new URLSearchParams({
    type,
    date,
    dateRange,
    ...(supportId ? { supportId } : {}),
  }).toString()}`;

  const url = routes.get.events + params;
  return axios.get(url, headers);
};

export const downloadEvents = ({ type, startDate, endDate }) => {
  const params = `?${new URLSearchParams({
    type,
    startDate,
    endDate,
  }).toString()}`;

  const url = routes.get.download + params;
  return axios.get(url, { ...headers, responseType: 'blob' });
};

export const getChatActionEndEventAggregates = ({
  date = getISODate(new Date()),
  dateRange = DATE_RANGE.DAY,
  department = DEPARTMENT.REGISTER,
  tag,
}) => {
  const params = `?${new URLSearchParams({
    date,
    dateRange,
    department,
    ...(tag ? { tag } : {}),
  }).toString()}`;

  const url = routes.get.chatActionEndEventAggregates + params;
  return axios.get(url, headers);
};
